import angular from 'angular';
import insuranceCardItemView from './insuranceCardItemView';

export default angular
  .module('scenes.clientInsurance.components', [])
  .component('insuranceCardItemView', insuranceCardItemView).name;
